import { render, staticRenderFns } from "./descriptionPicker.vue?vue&type=template&id=2a720752&scoped=true"
import script from "./descriptionPicker.vue?vue&type=script&lang=js"
export * from "./descriptionPicker.vue?vue&type=script&lang=js"
import style0 from "./descriptionPicker.vue?vue&type=style&index=0&id=2a720752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a720752",
  null
  
)

export default component.exports